<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Consultar PQR</h5>
        </div>
        <emt-grid ref="pqr-grid" v-bind:resource="gridUrl" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl" v-bind:btnDelete="btnDelete"
             v-bind:btnEdit="btnEdit" v-bind:btnDetail="btnDetail" v-bind:source="consult" >
        </emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default {
    name: 'emt-form-consult-pqr',
    data: function () {
        return {
            consult: 'consult',
            itemsGrid: [
                {
                    'name': 'id',
                    'label': 'ID PQR',
                    'ordering': true,
                    'filters': ['exact']
                },
                {
                    'name': 'status_display',
                    'label': 'Estado PQR',
                    'ordering': true,
                    'filters': ['exact'],
                    'filterList': Config.statusPqrList
                },
                {
                    'name': {
                        'object': 'type',
                        'key': 'name'
                    },
                    'label': 'Tipo PQR',
                    'value': null,
                    'ordering': true
                    // 'filters': ['exact'],
                    // 'filterList': Config.typePqrList()
                },
                {
                    'name': {
                        'object': 'reason',
                        'key': 'name'
                    },
                    'label': 'Motivo',
                    'value': null,
                    'ordering': true
                    // 'filters': ['exact', {
                    //     'name': 'icontains',
                    //     'label': 'Puede contener'
                    // }]
                },
                {
                    'name': {
                        'object': 'subreason',
                        'key': 'name'
                    },
                    'label': 'Submotivo',
                    'value': null,
                    'ordering': true
                    // 'filters': ['exact', {
                    //     'name': 'icontains',
                    //     'label': 'Puede contener'
                    // }]
                },
                // {
                //     'name': {
                //         'object': 'channel',
                //         'key': 'name'
                //     },
                //     'label': 'Canal',
                //     'value': null,
                //     'ordering': true,
                //     'filters': ['exact', {
                //         'name': 'icontains',
                //         'label': 'Puede contener'
                //     }]
                // },
                {
                    'name': 'account__document',
                    'label': 'Cédula',
                    'value': null,
                    'showGrid': false,
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                },
                {
                    'name': {
                        'object': 'account',
                        'key': 'document'
                    },
                    'label': 'Cédula',
                    'value': null,
                    'ordering': true
                },
                {
                    'name': 'account__name',
                    'label': 'Nombres',
                    'value': null,
                    'showGrid': false,
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                },
                {
                    'name': {
                        'object': 'account',
                        'key': 'name'
                    },
                    'label': 'Nombres',
                    'value': null,
                    'ordering': true
                },
                {
                    'name': 'account__surname',
                    'label': 'Apellidos',
                    'value': null,
                    'ordering': true,
                    'showGrid': false,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                },
                {
                    'name': {
                        'object': 'account',
                        'key': 'surname'
                    },
                    'label': 'Apellidos',
                    'value': null,
                    'ordering': true
                },
                {
                    'name': {
                        'object': 'unit',
                        'key': 'name'
                    },
                    'label': 'Unidad',
                    'value': null,
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                },
                {
                    'name': {
                        'object': 'area',
                        'key': 'name'
                    },
                    'label': 'Área',
                    'value': null,
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                },
                // {
                //     'name': {
                //         'object': 'user_assigned',
                //         'key': 'username'
                //     },
                //     'label': 'Usuario asignado',
                //     'value': null,
                //     'ordering': true,
                //     'filters': ['exact', {
                //         'name': 'icontains',
                //         'label': 'Puede contener'
                //     }]
                // },
                {
                    'name': {
                        'object': 'company',
                        'key': 'name'
                    },
                    'label': 'Empresa o filial',
                    'value': null,
                    'ordering': true
                    // 'filters': ['exact', {
                    //     'name': 'icontains',
                    //     'label': 'Puede contener'
                    // }]
                },
                {
                    'name': 'waiting_provider',
                    'label': 'Espera de proveedor',
                    'ordering': true
                },
                {
                    'name': 'created_at',
                    'label': 'Fecha creación',
                    'ordering': true
                    // 'filters': ['exact']
                },
                {
                    'name': 'date_expiry',
                    'label': 'Fecha expiración',
                    'ordering': true
                    // 'filters': ['exact']
                }
            ],
            config: Config,
            update: false,
            editUrl: '/UpdatePqr/',
            deleteUrl: Config.api + '/pqr/',
            btnDelete: true,
            btnEdit: false,
            btnDetail: true,
            idAreas: [],
            gridUrl: null
        }
    },
    methods: {
        reload: function () {
            this.$refs['pqr-grid'].reload()
        },
        areas: function () {
            return this.idAreas.join(',')
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        var self = this
        if (Cookies.get('perfil') === 'Administrador') {
            self.gridUrl = Config.api + '/pqr_full_data/'
        } else if (Cookies.get('perfil') !== 'Consulta filial') { // if (Cookies.get('perfil') !== 'Epm' && Cookies.get('perfil') !== 'Consulta filial') {
            // self.gridUrl = Config.api + '/pqr_full_data/'
            if (Cookies.get('perfil') === 'Emtelco') {
                self.gridUrl = Config.api + '/pqr_full_data/'
            } else {
                self.$http.get(Config.api + '/unit_user/?unit_user=' + Cookies.get('idUser')).then(function (response) {
                    self.gridUrl = Config.api + '/pqr_full_data/?unit__in=' + response.body.results[0].unit.id
                    self.reload()
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                })
            }
        } else if (Cookies.get('perfil') === 'Consulta filial') {
            self.$http.get(Config.api + '/company_user/?company_user=' + Cookies.get('idUser')).then(function (response) {
                self.gridUrl = Config.api + '/pqr_full_data/?company=' + response.body.results[0].company.id
                self.reload()
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
            // self.$http.get(Config.api + '/unit_user/?unit_user=' + Cookies.get('idUser')).then(function (response) {
            //     self.gridUrl = Config.api + '/pqr_full_data/?unit__in=' + response.body.results[0].unit.id
            //     self.reload()
            // }, function (response) {
            //     console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            // })
        } else {
            self.$http.get(Config.api + '/unit_user/?unit_user=' + Cookies.get('idUser')).then(function (response) {
                self.gridUrl = Config.api + '/pqr_full_data/?unit__in=' + response.body.results[0].unit.id
                self.reload()
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-consult-pqr.vue?625f1f1d